<template>
  <div class="social-mobile">
    <div class="social-category-container">
      <transition name="el-zoom-in-top" mode="out-in">
        <div class="new-post-area" v-if="newPost.length > 0" @click="$store.state.socialModule.identifier += 1">
          <div class="owner-list">
            <img width="32" height="32" v-for="(item, index) in newPost.filter(x => x.owner != null).slice(0, 3)" :key="item.id + '-new-post-area-' + index" :src="$imageus + (item.owner.image == null ? host + '/static/500x500-user.png' : item.owner.image) + '?width=200&height=200&mode=cover'" :alt="item.owner.title" />
          </div>
          <div class="text">+{{ newPost.length }} {{ $t("socialhub.newPost") }}</div>
        </div>
      </transition>

      <swiper class="right-category-wrapper" :options="swiperOption">
        <swiper-slide class="right-category-box">
          <button
            @click="
              currentHub = null;
              currentHubHasTopic = null;
              isOpen = true;
            "
            class="socialhub-category"
            :style="currentHub == null && isOpen ? 'background-color :' + currentEvent.color + '; color: white; border-color :' + currentEvent.color + ';' : ''"
          >
            <div class="icon-container">
              <i :style="(currentHub == null && isOpen ? 'filter: brightness(0) invert(1);' : '') + ';mask-image: url(/static/module/socialHub.svg); background-color: ' + currentEvent.color + ';'"></i>
            </div>
            <span v-show="currentHub == null && isOpen">{{ $t('socialhub.menu.hub') }}</span>
          </button>

          <button
            @click="
              currentHub = 0;
              currentHubHasTopic = true;
              isOpen = true;
            "
            class="socialhub-category"
            :style="currentHub == 0 && isOpen ? 'background-color :' + currentEvent.color + '; color: white; border-color :' + currentEvent.color + ';' : ''"
          >
            <div class="icon-container">
              <i :style="(currentHub == 0 && isOpen ? 'filter: brightness(0) invert(1);' : '') + ';mask-image: url(/static/module/socialChat.svg); background-color: ' + currentEvent.color + ';'"></i>
            </div>
            <span v-show="currentHub == 0 && isOpen">{{ $t('socialhub.menu.questionAnswer') }}</span>
          </button>

          <button
            @click="
              currentHub = 1;
              currentHubHasTopic = null;
              isOpen = true;
            "
            class="socialhub-category"
            :style="currentHub == 1 && isOpen ? 'background-color :' + currentEvent.color + '; color: white; border-color :' + currentEvent.color + ';' : ''"
          >
            <div class="icon-container">
              <i :style="(currentHub == 1 && isOpen ? 'filter: brightness(0) invert(1);' : '') + ';mask-image: url(/static/module/socialStats.svg); background-color: ' + currentEvent.color + ';'"></i>
            </div>
            <span v-show="currentHub == 1 && isOpen">{{ $t('socialhub.menu.voting') }}</span>
          </button>

          <button
            @click="
              currentHub = 2;
              currentHubHasTopic = null;
              isOpen = true;
            "
            class="socialhub-category"
            :style="currentHub == 2 && isOpen ? 'background-color :' + currentEvent.color + '; color: white; border-color :' + currentEvent.color + ';' : ''"
          >
            <div class="icon-container">
              <i :style="(currentHub == 2 && isOpen ? 'filter: brightness(0) invert(1);' : '') + ';mask-image: url(/static/module/socialSurvey.svg); background-color: ' + currentEvent.color + ';'"></i>
            </div>
            <span v-show="currentHub == 2 && isOpen">{{ $t('socialhub.menu.survey') }}</span>
          </button>
        </swiper-slide>
      </swiper>
    </div>
    <el-drawer title="Social Hub" :visible.sync="isOpen" direction="btt" size="90%" custom-class="social-mobile-drawer">
      <div>
        <SocialDrawer v-if="isOpen" />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import SocialDrawer from "./SocialDrawer.vue";

export default {
  data() {
    return {
      isOpen: false,
      currentHubHasTopic: this.$store.getters.getSocialTopicType,
      currentHub: this.$store.getters.getSocialType,
      swiperOption: {
        slidesPerView: "auto"
      }
    };
  },
  components: {
    SocialDrawer
  },
  methods: {
    handleClose() {}
  },
  computed: {
    newPost() {
      return this.$store.getters.getNewPost;
    },
    currentEvent() {
      return this.$store.getters.getEvent;
    },
    currentOrganisation() {
      return this.$store.getters.getOrganisation;
    },
    isAttending() {
      return this.$store.getters.getAttending;
    },
    topicType() {
      return this.$store.getters.getSocialTopicType;
    },
    type() {
      return this.$store.getters.getSocialType;
    }
  },
  watch: {
    topicType() {
      this.currentHubHasTopic = this.topicType;
    },
    type() {
      this.currentHub = this.type;
    },
    currentHubHasTopic: function() {
      this.$store.commit("changeSocialItemTopicType", this.currentHubHasTopic);
    },
    currentHub: function() {
      this.$store.commit("changeSocialItemType", this.currentHub);
    }
  }
};
</script>

<style lang="less">
.social-mobile-drawer {
  background: #e8ebef;
  overflow: hidden;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  header {
    display: none;
  }
}
.social-mobile {
  box-shadow: 0px 2px 10px rgba(196, 201, 210, 0.5);
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  position: absolute;
  overflow: hidden;
  width: 100%;
  bottom:0;

  background-color: red;
  & > .social-category-container {
    display: flex;
    background-color: white;
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding-bottom: 8px;
    border-bottom: 1px solid whitesmoke;
    position: relative;
    .new-post-area {
      position: absolute;
      padding: 9px;
      cursor: pointer;
      left: 50%;
      bottom: -53px;
      z-index: 2;
      transform: translateX(-50%);
      gap: 8px;
      display: flex;
      background: #03658c;
      align-items: center;
      border-radius: 64px;
      box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
      .owner-list {
        display: flex;
        flex-direction: row;
        flex-shrink: 0;
        img {
          flex-shrink: 0;
          width: 22.5px;
          height: 22.5px;
          border-radius: 50%;
          border: 1.5px solid #ffffff;
          margin-left: -8px;
          &:first-child {
            margin-left: 0;
          }
        }
      }
      .text {
        flex-shrink: 0;
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        color: white;
      }
    }
  }
  .right-category-wrapper {
    width: 100%;
    display: flex;
    flex-direction: row;
    margin-bottom: 4px;
    margin-top: 8px;
    padding-left: 6px;

    .right-category-box {
      display: flex;
      flex-direction: row;
      justify-content: space-around;

      .socialhub-category-passive {
        opacity: 0.5;
        filter: grayscale(100%);
        cursor: not-allowed !important;
        cursor: no-drop !important;
      }

      .socialhub-category {
        background: #fff;
        border: unset !important;
        padding: 8px 10px;
        border-radius: 30px;
        margin-right: 6px;
        cursor: pointer;
        font-family: "Roboto";
        color: #8c929c;
        white-space: nowrap;
        display: flex;
        align-items: center;
        transition: all 0.2s ease-in-out;

        .icon-container {
          width: 25px;
          height: 25px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          text-decoration: none;

          i {
            margin-bottom: 0px;
            display: block;
            background-position: 50%;
            background-repeat: no-repeat;
            background-size: contain;
            height: 25px;
            width: 25px;
            cursor: pointer;
            mask-repeat: no-repeat;
            mask-position: center;
          }
        }

        span {
          font-size: 14px;
          font-weight: 500;
          margin-left: 6px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/SocialMobile.vue